import React, { useEffect, useRef } from "react";
import { useAppSelector } from "../../../store/index.ts";
import ShowContainer from "../../mui/ShowContainer.jsx";

export default function TgWidgetContainer() {
  const tgPostUrl = useAppSelector((state) => state.links.tgPostUrl);
  const telegramWrapperRef = useRef(null);

  // useEffect(() => {
  //   const aside = document.getElementById(idAsideMenu);
  //   const $frame = document.getElementById("container-widget");
  //   const $place = aside.querySelector("#container-widget-place");
  //   if ($place && $frame) $place.appendChild($frame);

  //   // return () => {
  //   //   if ($frame) document.body.appendChild($frame);
  //   // };
  // }, [idAsideMenu]);

  useEffect(() => {
    const postUrl = tgPostUrl.replace("https://t.me/", "").replace("http://t.me/", "");
    telegramWrapperRef.current.innerHTML = "";
    const scriptElement = document.createElement("script");
    scriptElement.src = "https://telegram.org/js/telegram-widget.js?22";
    scriptElement.setAttribute("data-telegram-post", postUrl);
    scriptElement.setAttribute("data-dark", "1");
    scriptElement.setAttribute("data-height", "600");
    scriptElement.async = true;

    telegramWrapperRef.current.appendChild(scriptElement);
  }, [tgPostUrl]);

  return (
    <ShowContainer condition={!!tgPostUrl}>
      <div className="widget_container" id="container-widget-place">
        <div id="container-widget" ref={telegramWrapperRef}></div>
      </div>
    </ShowContainer>
  );
}
